import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  EventEmitter,
  Output,
} from "@angular/core";
import * as _ from "lodash";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TableField } from "../../../models/table/table.field.model";
import { Table } from "../../../models/table/table.model";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ToastService } from "src/app/services/toast/toast.service";

import { DynamicBaseForm } from "./dynamic-form/models/dynamic-base-form";
import { TextBoxNumberForm } from "./dynamic-form/models/textbox-number-form";
import { TextBoxStringForm } from "./dynamic-form/models/textbox-string-form";
import { TitleForm } from "./dynamic-form/models/title-form";
import { CheckBoxForm } from "./dynamic-form/models/textbox-boolean-form";

import { User } from "src/app/models/user.model";
import { Subscription } from "rxjs";
import {
  GridDataType,
  TableFieldData,
} from "src/app/models/table/table.gtid.model";
import { TableService } from "src/app/services/table/table.service";
import { TableEnvironment } from "src/app/models/table/table.env.model";

import { forEach } from "lodash";
import { StructForm } from "./dynamic-form/models/struct-form";
import { ItemsList } from "@ng-select/ng-select/lib/items-list";

@Component({
  selector: "app-tablas-form",
  templateUrl: "./tablas-form.component.html",
  styleUrls: ["./tablas-form.component.scss"],
})
export class TablasFormComponent implements OnDestroy, OnInit {
  form!: FormGroup;
  payLoad = "";
  rowsDataForm: DynamicBaseForm<string>[] | null = [];
  dataStructForm: StructForm[];

  subcriptions: Subscription[] = [];
  browserLang: string;

  @Input() fieldsTable: TableField[];
  @Input() recordToEdit: GridDataType;
  @Input() formMode: string;
  @Input() tableSelected: string;

  @Output() cancelEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() editEmitter: EventEmitter<GridDataType> =
    new EventEmitter<GridDataType>();
  @Output() addEmitter: EventEmitter<GridDataType> =
    new EventEmitter<GridDataType>();

  constructor(
    private tableService: TableService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    if (!this.browserLang || this.browserLang.length <= 0) {
      let currentUser: User = JSON.parse(localStorage.getItem("loggedUser"));
      this.browserLang =
        currentUser && currentUser.language
          ? currentUser.language
          : this.translate.getDefaultLang();
    }

    this.subcriptions.push(
      this.translate.onLangChange.subscribe((eventLang) => {
        this.browserLang = eventLang.lang;
      })
    );

    this.initFormData();
    this.form = this.toFormGroup();
  }

  initFormData() {
    if (this.rowsDataForm == null) {
      this.rowsDataForm = [];
    }

    if (this.dataStructForm == null) {
      this.dataStructForm = [];
    }

    this.fieldsTable.forEach((rowData) => {
      if (TableEnvironment.lstTypeAllowForm.indexOf(rowData.tipo) > -1) {
        if (rowData.tipo == "Object") {
          this.rowsDataForm.push(this.getControlDataForm(rowData));

          this.initFormDataRecursive(
            rowData.childField,
            rowData.nombre_en,
            rowData.nombre_es
          );

          let tempDataForm = this.getControlDataForm(rowData);
          tempDataForm.label_en = tempDataForm.label_en;
          tempDataForm.label_es = tempDataForm.label_es;

          this.dataStructForm.push({
            dataForm: tempDataForm,
            children: this.initStructFormDataRecursive(
              rowData.childField,
              tempDataForm.label_en,
              tempDataForm.label_es
            ),
            showOpen:
              rowData.childField.where((item) => item.isRequired).length > 0,
          });
        } else {
          this.rowsDataForm.push(this.getControlDataForm(rowData));

          this.dataStructForm.push({
            dataForm: this.getControlDataForm(rowData),
            children: [],
            showOpen: false,
          });
        }
      }
    });
  }

  initFormDataRecursive(
    childFieldsTable: TableField[],
    titleRecursiveEn: string,
    titleRecursiveEs: string
  ) {
    //}: DynamicBaseForm<string>[] {
    childFieldsTable.forEach((rowData) => {
      if (TableEnvironment.lstTypeAllowForm.indexOf(rowData.tipo) > -1) {
        if (rowData.tipo == "Object") {
          let tempDataForm = this.getControlDataForm(rowData);
          tempDataForm.label_en =
            titleRecursiveEn + "->" + tempDataForm.label_en;
          tempDataForm.label_es =
            titleRecursiveEs + "->" + tempDataForm.label_es;

          this.rowsDataForm.push(tempDataForm);
          this.initFormDataRecursive(
            rowData.childField,
            tempDataForm.label_en,
            tempDataForm.label_es
          );
        } else {
          this.rowsDataForm.push(this.getControlDataForm(rowData));
        }
      }
    });
  }

  initStructFormDataRecursive(
    childFieldsTable: TableField[],
    titleRecursiveEn: string,
    titleRecursiveEs: string
  ): StructForm[] {
    //}: DynamicBaseForm<string>[] {
    let tempDataStructForm: StructForm[] = [];
    childFieldsTable.forEach((rowData) => {
      if (TableEnvironment.lstTypeAllowForm.indexOf(rowData.tipo) > -1) {
        if (rowData.tipo == "Object") {
          let tempDataForm = this.getControlDataForm(rowData);
          tempDataForm.label_en = tempDataForm.label_en;
          tempDataForm.label_es = tempDataForm.label_es;

          tempDataStructForm.push({
            dataForm: tempDataForm,
            children: this.initStructFormDataRecursive(
              rowData.childField,
              tempDataForm.label_en,
              tempDataForm.label_es
            ),
            showOpen:
              rowData.childField.where((item) => item.isRequired).length > 0,
          });
        } else {
          tempDataStructForm.push({
            dataForm: this.getControlDataForm(rowData),
            children: [],
            showOpen: false,
          });
        }
      }
    });

    return tempDataStructForm;
  }

  getControlDataForm(rowData: TableField): any {
    if (rowData.tipo == "Object") {
      //no recuerdo los otros tipos de datos verificar
      return new TitleForm({
        key: rowData.uuid,
        label_en: rowData.nombre_en,
        label_es: rowData.nombre_es,
        type: "title",
        value: null,
      });
    }

    let tempData: any = {
      key: rowData.uuid,
      label_en: rowData.nombre_en,
      label_es: rowData.nombre_es,
      value:
        this.formMode == "EDIT"
          ? this.getValueToEdit(this.recordToEdit, rowData.uuid)
          : "", //por el momento se manda vacía
      required: rowData.isRequired,
    };

    if (rowData.tipo == "String") {
      tempData.type = "text";
      return new TextBoxStringForm(tempData);
    } else if (rowData.tipo == "Float" || rowData.tipo == "Int") {
      //no recuerdo los otros tipos de datos verificar
      tempData.type = "number";
      return new TextBoxNumberForm(tempData);
    } else if (rowData.tipo == "Boolean") {
      tempData.type = "boolean";
      if (tempData.value == null || tempData.value == "")
        tempData.value = false;
      return new CheckBoxForm(tempData);
    } else {
      return null;
    }
  }

  getValueToEdit(valuesForm: GridDataType, uuid: string): string {
    let tempFieldData: GridDataType[] = [];

    for (let columnKey of Object.keys(valuesForm)) {
      if (uuid == columnKey) {
        if (valuesForm[uuid].type != TableEnvironment.OBJECT_TYPE) {
          return valuesForm[uuid].value;
        }
      }

      if (valuesForm[columnKey].childRow) {
        tempFieldData = tempFieldData.concat(valuesForm[columnKey].childRow);
      }
    }
    for (let index = 0; index < tempFieldData.length; index++) {
      let sss: string;
      sss = this.getValueToEdit(tempFieldData[index], uuid);
      if (sss != null) return sss;
    }

    return null;
  }

  toFormGroup() {
    const group: any = {};

    this.rowsDataForm.forEach((itemForm) => {
      try {
        group[itemForm.key] = itemForm.required
          ? new FormControl(
              itemForm.value !== null && itemForm.value !== undefined
                ? itemForm.value
                : "",
              Validators.required
            )
          : new FormControl(
              itemForm.value !== null && itemForm.value !== undefined
                ? itemForm.value
                : ""
            );
      } catch (error) {
        console.log(error);
      }
    });

    return new FormGroup(group);
  }

  submitForm() {
    if (!this.form.invalid) {
      if (this.formMode == "EDIT") {
        this.editRecord();
      } else {
        this.createRecord();
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  private editRecord() {
    this.subcriptions.push(
      this.tableService
        .editTipoDatoTableData(
          this.tableSelected,
          this.recordToEdit.id,
          this.getNewEditInputRecord()
        )
        .subscribe((data) => {
          let response = data["updateTipoDatoTableData"];
          if (response && response["_id"]) {
            this.editEmitter.emit(this.form.getRawValue());
          } else {
            //this.translate.get('ALARMAS.ALARMAS_CREATE_ERROR').subscribe(value => auxMessage = value);
            //this.translate.get('ALARMAS.ERROR').subscribe(value => auxMessage2 = value);
            //this.toastr.showError(auxMessage, auxMessage2);
            alert("Error al editar registro");
          }
        })
    );
  }

  private createRecord() {
    this.subcriptions.push(
      this.tableService
        .addTipoDatoTableData(this.tableSelected, this.getNewEditInputRecord())
        .subscribe((data) => {
          let response = data["insertTipoDatoTableData"];
          if (response && response["_id"]) {
            this.addEmitter.emit(this.form.getRawValue());
          } else {
            //this.translate.get('ALARMAS.ALARMAS_CREATE_ERROR').subscribe(value => auxMessage = value);
            //this.translate.get('ALARMAS.ERROR').subscribe(value => auxMessage2 = value);
            //this.toastr.showError(auxMessage, auxMessage2);
            alert("Error al crear registro");
          }
        })
    );
  }

  private getNewEditInputRecord(): string {
    let newRecordData: any = this.form.getRawValue();
    let inputNewRecord: string = "";

    inputNewRecord = "["; //'{\n"uuidTable": "' + this.tableSelected + '",\n \"input\": [';

    this.fieldsTable.forEach((rowField) => {
      if (TableEnvironment.lstTypeAllowForm.indexOf(rowField.tipo) > -1) {
        if (rowField.tipo == "Object") {
          inputNewRecord =
            inputNewRecord +
            `{
                        "code": "${rowField.codigo_df}", 
                        "${rowField.tipo.toLowerCase()}Value": [
                            ${this.getNewInputRecordRecursive(
                              rowField.childField,
                              newRecordData
                            )}
                        ]
                    },`;
        } else {
          inputNewRecord =
            inputNewRecord +
            `{
                        "code": "${rowField.codigo_df}", 
                        "${rowField.tipo.toLowerCase()}Value": ${this.getRowValueByUuidField(
              rowField.uuid,
              newRecordData,
              rowField.tipo
            )}
                    },`;
        }
      }
    });

    inputNewRecord =
      inputNewRecord.substring(0, inputNewRecord.length - 1) + "]";
    return inputNewRecord;
  }

  private getNewInputRecordRecursive(
    fieldsTableChildren: TableField[],
    newRecordDataChildren: any
  ): string {
    let inputNewRecord: string = "";
    let newRecordData: any = this.form.getRawValue();

    fieldsTableChildren.forEach((rowField) => {
      if (TableEnvironment.lstTypeAllowForm.indexOf(rowField.tipo) > -1) {
        if (rowField.tipo == "Object") {
          inputNewRecord =
            inputNewRecord +
            `{
                        "code": "${rowField.codigo_df}", 
                        "${rowField.tipo.toLowerCase()}Value": [
                            ${this.getNewInputRecordRecursive(
                              rowField.childField,
                              newRecordData
                            )}
                        ]
                    },`;
        } else {
          inputNewRecord =
            inputNewRecord +
            `{
                        "code": "${rowField.codigo_df}", 
                        "${rowField.tipo.toLowerCase()}Value": ${this.getRowValueByUuidField(
              rowField.uuid,
              newRecordDataChildren,
              rowField.tipo
            )}
                    },`;
        }
      }
    });

    return inputNewRecord.substring(0, inputNewRecord.length - 1);
  }

  private getRowValueByUuidField(
    uuidField: string,
    recordData: any,
    type: string
  ): string {
    let valueField: string = recordData[uuidField];
    switch (type) {
      case TableEnvironment.FLOAT_TYPE:
        return valueField !== null && valueField !== undefined
          ? valueField.toString()
          : "null";
      case TableEnvironment.STRING_TYPE:
        return valueField !== null && valueField !== undefined
          ? `"${valueField}"`
          : "null";
      case TableEnvironment.BOOLEAN_TYPE:
        return valueField !== null && valueField !== undefined
          ? valueField
          : "null";
      case TableEnvironment.INT_TYPE:
        return valueField !== null && valueField !== undefined
          ? valueField
          : "null";
      case TableEnvironment.BOOLEAN_TYPE:
        return valueField !== null && valueField !== undefined
          ? valueField
          : "false";
      default:
        return valueField !== null && valueField !== undefined
          ? valueField
          : "null";
    }
  }

  cancelForm() {
    this.cancelEmitter.emit(true);
  }

  ngOnDestroy(): void {
    this.subcriptions.forEach((s) => {
      s.unsubscribe();
    });
  }
}
